module.exports = __webpack_public_path__ + "static/img/8c.510d244.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/8c.jpg
// module id = dyPF
// module chunks = 0